module.exports = __webpack_public_path__ + "img/icon-douyin.e0d8c2dd.png";